import { createFileRoute } from '@tanstack/react-router';
import { ResourceLibraryPage } from '@/pages/chain/ResourceLibraryPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { z } from 'zod';

const searchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	search: z.string().optional(),
	categoryId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/chain/resources')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainContent.authorResources'], redirectTo: '/dashboard' }),
	validateSearch: searchSchema,
	component: ResourceLibraryPage,
});
